import LogLevel from './logLevels';

/**
 * Customized Types due to our custom LogLevels
 */
export default {
	// Silent
	silent: {
		level: -1,
	},
	// Level 0
	fatal: {
		level: LogLevel.Fatal,
	},
	error: {
		level: LogLevel.Error,
	},
	// Level 1
	warn: {
		level: LogLevel.Warn,
	},
	// Level 2
	info: {
		level: LogLevel.Info,
	},
	// Level 3
	log: {
		level: LogLevel.Log,
	},
	success: {
		level: LogLevel.Success,
	},
	// Level 4
	debug: {
		level: LogLevel.Debug,
	},
	// Level 5
	trace: {
		level: LogLevel.Trace,
	},
	// Verbose
	verbose: {
		level: LogLevel.Trace,
	},

	// Legacy
	ready: {
		level: LogLevel.Info,
	},
	start: {
		level: LogLevel.Info,
	},
};
